module.exports = __webpack_public_path__ + "img/advantages-icon.dec0110.svg";